import "./info-popup.scss";

import React from "react";
import classNames from "classnames";

const InfoPopup = ({ children, onEnd, dismiss }) => {
   return (
      <div
         className={classNames("info-popup", {
            ["info-popup--fadeout"]: onEnd === "",
         })}
      >
         <div className="row">
            <div className="col-2 d-flex justify-content-center align-items-center">
               <img
                  src={require("../../assets/icons/x.svg").default}
                  alt="Ostrzeżenie"
                  className="info-popup__icon"
               />
            </div>
            <div className="col-10">{children}</div>
         </div>
         <button
            type="button"
            className="info-popup__dismiss"
            onClick={dismiss}
         >
            <img
               src={require("../../assets/icons/x.svg").default}
               alt="Zamknij powiadomienie"
               className="info-popup__icon info-popup__icon--dismiss"
            />
         </button>
      </div>
   );
};

export default InfoPopup;
